<template>
    <div>
      <div class="survey-module-right-action">
            <div class="table-controls justify-between">
              <div class="table-controls-btn align-center justify-between">
                <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增</div>
                <div class="align-center justify-between">
                  <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
                  <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
                </div>
              </div>
            </div>
            <div class="table-controls justify-between">
              <div class="table-controls-btn">
                <input type="text" v-model="queryParams.username" placeholder="请输入账号" autocomplete="off">
              </div>
            </div>
            <div class="table-body">
              <el-table 
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{background:'#72b701',color:'#fff'}"
              >
                <el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="head" label="昵称" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true"></el-table-column>
                
                <el-table-column
                  fixed="right"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <el-button @click="handleOpen(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button type="text" size="small" @click="deleteItemFun(scope.row.id)">删除</el-button>
                    <el-button type="text" size="small" @click="handleOpenMima(scope.row)">修改密码</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-content justify-end">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
          :title="dialog.title"
          :visible.sync="dialog.visible"
          width="95%"
          :before-close="closeDialog"
          >
          <div class="login-form-box">
            <el-form :model="referForm" :rules="referRules" ref="referForm">
              <el-form-item prop="username" v-if="dialog.title!='修改密码'">
                <input v-model="referForm.username" placeholder="账号" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="password" v-if="dialog.title!='编辑'">
                <input v-model="referForm.password" placeholder="密码" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="head" v-if="dialog.title!='修改密码'">
                <input v-model="referForm.head" placeholder="昵称" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="phone" v-if="dialog.title!='修改密码'">
                <input v-model="referForm.phone" placeholder="手机号" autocomplete="new-password">
              </el-form-item>
              <el-form-item>
                <div class="login-form-btn justify-center align-center" @click="handleSubmit('referForm')">提交{{ dialog.title }}</div>
              </el-form-item>
            </el-form>
           </div>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { getList, addItem, editItem, delItem } from "@/api/pxjd";
  export default {
    data(){
      return{
        loading:false,
        // 列表1-start
        queryParams:{
          pageNum: 1,
          pageSize: 10,
          username: "",
        },
        total:0,
        tableData: [],
        dialog:{
          title:'',
          visible:false
        },
        referForm: {
          id: undefined,
          username: "",
          password: "",
          phone: "",
          head: "",
        },
        referRules: {
          username: [{ required: true, message: "请输入账号", trigger: "blur" }],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
          head: [{ required: true, message: "请输入基地昵称", trigger: "blur" }],
          phone: [{ required: true, message: "请输入基地手机号", trigger: "blur" }],
        },
        // 列表1-end
        identity:localStorage.getItem("identity")
      }
    },
    created(){
      if(this.identity=='admin'){
        this.handleQuery()
      }
    },
    methods:{
      handleOpen(row){
        if(row){
          for(let key in this.referForm){
            this.referForm[key] = row[key]
          }
        }
        this.dialog.title = row?'编辑':'新增'
        this.dialog.visible = true
      },
      handleOpenMima(row){
        this.dialog.title = '修改密码'
        this.referForm.id = row.id
        this.dialog.visible = true
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.handleQuery()
      },
   
      /** 查询 */
      handleQuery() {
        this.loading = true;
        getList(this.queryParams)
          .then(({ data }) => {
            this.tableData = data.list;
            this.total = data.total;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      /** 角色保存提交 */
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            const roleId = this.referForm.id;
            if (roleId) {
              editItem(roleId, this.dialog.title == '修改密码'?{password:this.referForm.password}:this.referForm)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            } else {
              addItem(this.referForm)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            }
          }
        });
      },
      /** 关闭表单弹窗 */
      closeDialog() {
        this.dialog.visible = false;
        this.resetForm();
      },
      /** 重置表单 */
      resetForm() {
        this.referForm.id = undefined;
        this.referForm.username = '';
        this.referForm.password = '';
        this.referForm.head = '';
        this.referForm.phone = '';
        this.queryParams.pageNum = 1
        this.handleQuery()
      },
      /** 重置查询 */
      resetQuery() {
        this.queryParams.pageNum = 1;
        this.queryParams.username = ''
        this.handleQuery();
      },
      deleteItemFun(id){ 
        this.$confirm('此操作将永久删除此会员, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delItem([id]).then((res)=>{
              this.handleQuery()
              this.$message({
                type: 'success',
                message: res.message
              });
            })
           
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },
    }
  }
  </script>
<style scoped lang="css" src="../../views/matrix-page/assets/css/base.css" />